import * as Joi from "joi";
import { Moment } from 'moment';
import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { GenPartial, momentTransformer } from 'typeormgen';
import EpisodicBase from '../episodic-base.entity';

@Entity('ha_change_field_names')
export default class HaChangeFieldNames extends EpisodicBase {
	static tableName = 'ha_change_field_names';

	static displayFields = [
		'h_description',
		'wig_hp',
		'wig_hp_source',
		'h_period',
		'h_products',
		'h_note',
		'hair_ornaments',
		'hair_color_formula',
		'maintenance',
		'tools',
	];

	@PrimaryGeneratedColumn()
	id: number;

	@Column('int')
	episodic_id: number;

	@Column('varchar')
	h_description: string;

	@Column('varchar')
	wig_hp: string;

	@Column('varchar')
	wig_hp_source: string;

	@Column('varchar')
	h_period: string;

	@Column('varchar')
	h_products: string;

	@Column('varchar')
	h_note: string;

	@Column('varchar')
	hair_ornaments: string;

	@Column('varchar')
	hair_color_formula: string;

	@Column('varchar')
	maintenance: string;

	@Column('varchar')
	tools: string;

	@Column('int')
	created_by: number;

	@Column('int')
	last_updated_user: number;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	date_created: Moment;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	last_updated_time: Moment;

	static rules() {
		return {
			id: Joi.number().integer(),
			episodic_id: Joi.number().integer().allow(null),
			h_description: Joi.string().max(255),
			wig_hp: Joi.string().max(255),
			wig_hp_source: Joi.string().max(255),
			h_period: Joi.string().max(255),
			h_products: Joi.string().max(255),
			h_note: Joi.string().max(255),
			hair_ornaments: Joi.string().max(255),
			hair_color_formula: Joi.string().max(255),
			maintenance: Joi.string().max(255),
			tools: Joi.string().max(255),
			created_by: Joi.number().integer(),
			last_updated_user: Joi.number().integer(),
			date_created: Joi.date().allow(null),
			last_updated_time: Joi.date().allow(null),
		};
	}

	toJSON() {
		return {
			id: this.id,
			episodic_id: this.episodic_id,
			h_description: this.h_description,
			wig_hp: this.wig_hp,
			wig_hp_source: this.wig_hp_source,
			h_period: this.h_period,
			h_products: this.h_products,
			h_note: this.h_note,
			hair_ornaments: this.hair_ornaments,
			hair_color_formula: this.hair_color_formula,
			maintenance: this.maintenance,
			tools: this.tools,
			created_by: this.created_by,
			last_updated_user: this.last_updated_user,
			date_created: this.date_created,
			last_updated_time: this.last_updated_time,
		};
	}

	assign(props?: GenPartial<HaChangeFieldNames>) {
		super.assign(props);

		if (props) {
			if (typeof props.date_created !== 'undefined') {
				this.date_created = momentTransformer.from(props.date_created);
			}
			if (typeof props.last_updated_time !== 'undefined') {
				this.last_updated_time = momentTransformer.from(
					props.last_updated_time
				);
			}
		}
	}

	constructor(props?: GenPartial<HaChangeFieldNames>) {
		super(props);
	}
}
